import styled from 'styled-components';
import { absFull } from 'helpers/styles.js';
import rightArrowIcon from 'images/icons/right-arrow.svg';
import searchIconWhite from 'images/icons/searchIconWhite.svg';

export const SearchHeaderContainer = styled.div`
  width: 100%;
  height: 478px;
  background: #0b1723;
  padding-top: 160px;
  position: relative;
  overflow: hidden;
  z-index: 1;
`;

export const SearchHeaderWrapper = styled.div`
  width: 100%;
  height: 478px;
`;

export const StyledSearchInput = styled.input`
  font-family: Brandon;
  width: 84%;
  border: 0;
  background: none;
  font-size: 18px;
  color: white;

  &::placeholder {
    color: white;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 26px;
  }

  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.div`
  background: url('${searchIconWhite}');
  width: 12px;
  height: 12px;
  margin-right: 30px;
  display: inline-block;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  vertical-align: middle;
`;

export const SearchContainer = styled.form`
  min-height: 51px;
  width: 100%;
  max-width: 751px;
  margin: 0 auto 27px auto;
  padding: 10px 0 5px 0;
  border-bottom: 1px solid #82B2DB;
  white-space: nowrap;
`;

export const StyledAdvancedSearchLink = styled.div`
  display: block;
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.palette[5]};

  &:hover {
    cursor: pointer;
  }
`;

export const ContinueArrowIcon = styled.div`
  width: 11px;
  height: 9px;
  display: inline-block;
  vertical-align: middle;
  background-image: url('${rightArrowIcon}');
  margin: 0 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const SearchButton = styled.div`
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 6px 10px;
  margin: 4px 8px 4px 0;
  border-radius: 20px;
  line-height: 14px;
  height: 27px;
  font-size: 9px;
  color: white;
  background-color: ${({ theme }) => theme.colors.palette[5]};
  border: ${({ theme }) => `1px solid ${theme.colors.palette[5]}}`};
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  opacity: ${({ show }) => show ? 1 : 0};

  &:hover {
    cursor: pointer;
    background-color: white;
    border-color: white;
    color: ${({ theme }) => theme.colors.palette[5]};
  }
`;

export const SearchSection = styled.div`
  background: rgba(0,0,0,0.7);
  ${absFull()};
  padding-top: 160px;
  z-index: 1;


  &:before {
    ${absFull()};
    content: '';
    background: linear-gradient(146.56deg, #213E58 0%, #446D93 51.04%, #6994BB 100%);
    opacity: .3;
    z-index: -1;
  }
`;
